export default __webpack_public_path__ + "static/media/sub_header_bg_mobile.6bc05fbe.png";